export const experienceData = [
    {
        id: 1,
        company: 'BRIDGEON SOLUTION',
        jobtitle: 'MERN STACK DEVELOPER',
        startYear: 'DEC 2022',
        endYear: 'JULY 2023'
    },
    {
        id: 2,
        company: 'ITMARKERZ TECHNOLOGY',
        jobtitle: 'Junior Nextjs Developer',
        startYear: 'AUG 2023',
        endYear: 'Present'
    }
]